// extracted by mini-css-extract-plugin
module.exports = {"container":"e__G","icon":"e_0G"};